export default "__VITE_ASSET__c2252246__"